export enum OrderStatusEnum
{
    Confirmed = 'Confirmed',
    Canceled = 'Canceled'
}

export const OrderStatusOptions = (): Option[] => ([
    { value: OrderStatusEnum.Confirmed, text: $t('[[[Potwierdzone]]]') },
    { value: OrderStatusEnum.Canceled, text: $t('[[[Anulowane]]]') }
]);

export const OrderStatusName = (value: OrderStatusEnum): string => OrderStatusOptions().find(p => p.value === value)?.text || OrderStatusEnum[value];

// ----------------------------------------------------------------------------------------------------

export enum PaymentTypeEnum
{
    Card = 'Card',
    Blik = 'Blik',
    PayU = 'PayU'
}

export const PaymentTypeOptions = (): Option[] => ([
    { value: PaymentTypeEnum.Card, text: $t('[[[Karta]]]') },
    { value: PaymentTypeEnum.Blik, text: $t('[[[Blik]]]') },
    { value: PaymentTypeEnum.PayU, text: $t('[[[PayU]]]') }
]);

export const PaymentTypeName = (value: PaymentTypeEnum): string => PaymentTypeOptions().find(p => p.value === value)?.text || PaymentTypeEnum[value];

// ----------------------------------------------------------------------------------------------------

export enum PaymentStatusEnum
{
    PENDING = 'PENDING',
    WAITING_FOR_CONFIRMATION = 'WAITING_FOR_CONFIRMATION',
    COMPLETED = 'COMPLETED',
    CANCELED = 'CANCELED'
}

export const PaymentStatusOptions = (): Option[] => ([
    { value: PaymentStatusEnum.PENDING, text: $t('[[[Oczekuje na płatność]]]') },
    { value: PaymentStatusEnum.WAITING_FOR_CONFIRMATION, text: $t('[[[Oczekuje na potwierdzenie]]]') },
    { value: PaymentStatusEnum.COMPLETED, text: $t('[[[Zakończone]]]') },
    { value: PaymentStatusEnum.CANCELED, text: $t('[[[Anulowane]]]') }
]);

export const PaymentStatusName = (value: PaymentStatusEnum): string => PaymentStatusOptions().find(p => p.value === value)?.text || PaymentStatusEnum[value];

// ----------------------------------------------------------------------------------------------------

export enum PaymentOperatorEnum
{
    PayU = 'PayU'
}

export const PaymentOperatorOptions = (): Option[] => ([
    { value: PaymentOperatorEnum.PayU, text: $t('[[[PayU]]]') }
]);

export const PaymentOperatorName = (value: PaymentOperatorEnum): string => PaymentOperatorOptions().find(p => p.value === value)?.text || PaymentOperatorEnum[value];

// ----------------------------------------------------------------------------------------------------

export enum SystemResponseRatingEnum
{
    Helpful = 'Helpful',
    UnHelpful = 'UnHelpful',
    NotRelated = 'NotRelated'
}

export const SystemResponseRatingOptions = (): Option[] => ([
    { value: SystemResponseRatingEnum.Helpful, text: $t('[[[Pomocna]]]') },
    { value: SystemResponseRatingEnum.UnHelpful, text: $t('[[[Nie pomocna]]]') },
    { value: SystemResponseRatingEnum.NotRelated, text: $t('[[[Nie związana]]]') }
]);

export const SystemResponseRatingName = (value: SystemResponseRatingEnum): string => SystemResponseRatingOptions().find(p => p.value === value)?.text || SystemResponseRatingEnum[value];

// ----------------------------------------------------------------------------------------------------

export enum PriceFormatEnum
{
    Gross = 'gross',
    Net = 'net'
}

// ----------------------------------------------------------------------------------------------------

export enum BorderStyleEnum
{
    None = 'none',
    Dashed = 'dashed',
    Dotted = 'dotted',
    Solid = 'solid'
}

export const BorderStyleOptions = (): Option[] => ([
    { value: BorderStyleEnum.None, text: $t('[[[Brak]]]') },
    { value: BorderStyleEnum.Dashed, text: $t('[[[Serie kresek lub fragmentów linii]]]') },
    { value: BorderStyleEnum.Dotted, text: $t('[[[Serie kropek]]]') },
    { value: BorderStyleEnum.Solid, text: $t('[[[Pojedyńcza, prosta, ciągła linia]]]') }
]);

// ----------------------------------------------------------------------------------------------------

export enum TextDecorationStyleEnum
{
    Solid = 'solid',
    Double = 'double',
    Dotted = 'dotted',
    Dashed = 'dashed',
    Wavy = 'wavy'
}

export const TextDecorationStyleOptions = (): Option[] => ([
    { value: TextDecorationStyleEnum.Solid, text: $t('[[[Linia ciągła]]]') },
    { value: TextDecorationStyleEnum.Double, text: $t('[[[Podwójna linia ciągła]]]') },
    { value: TextDecorationStyleEnum.Dotted, text: $t('[[[Linia kropkowana]]]') },
    { value: TextDecorationStyleEnum.Dashed, text: $t('[[[Linia kreskowana]]]') },
    { value: TextDecorationStyleEnum.Wavy, text: $t('[[[Linia falująca]]]') }
]);

// ----------------------------------------------------------------------------------------------------

export enum DeliveryTypeEnum
{
    Courier = 'Courier',
    ParcelMachine = 'ParcelMachine',
    PersonalCollection = 'PersonalCollection'
}

export const DeliveryTypeOptions = (): Option[] => ([
    { value: DeliveryTypeEnum.Courier, text: $t('[[[Kurier]]]') },
    { value: DeliveryTypeEnum.ParcelMachine, text: $t('[[[Automat paczkowy]]]') },
    { value: DeliveryTypeEnum.PersonalCollection, text: $t('[[[Odbiór osobisty]]]') }
]);

// ----------------------------------------------------------------------------------------------------

export enum StoreOrderStatusEnum
{
    New = 'New',
    PaymentPending = 'PaymentPending',
    Confirmed = 'Confirmed',
    InProgress = 'InProgress',
    Sent = 'Sent',
    Completed = 'Completed',
    Cancelled = 'Cancelled',
    Return = 'Return',
    Failed = 'Failed',
    Suspended = 'Suspended'
}

export const StoreOrderStatusOptions = (): Option[] => ([
    { value: StoreOrderStatusEnum.New, text: $t('[[[Nowe]]]') },
    { value: StoreOrderStatusEnum.PaymentPending, text: $t('[[[Oczekuje na płatność]]]') },
    { value: StoreOrderStatusEnum.Confirmed, text: $t('[[[Potwierdzone]]]') },
    { value: StoreOrderStatusEnum.InProgress, text: $t('[[[W trakcie realizacji]]]') },
    { value: StoreOrderStatusEnum.Sent, text: $t('[[[Wysłane]]]') },
    { value: StoreOrderStatusEnum.Completed, text: $t('[[[Zrealizowane]]]') },
    { value: StoreOrderStatusEnum.Suspended, text: $t('[[[Wstrzymane]]]') },
    { value: StoreOrderStatusEnum.Failed, text: $t('[[[Nieudane]]]') },
    { value: StoreOrderStatusEnum.Return, text: $t('[[[Zwrot]]]') },
    { value: StoreOrderStatusEnum.Cancelled, text: $t('[[[Anulowane]]]') }
]);

export const StoreOrderStatusName = (value: StoreOrderStatusEnum): string => StoreOrderStatusOptions().find(p => p.value === value)?.text || StoreOrderStatusEnum[value];

// ----------------------------------------------------------------------------------------------------

export enum StorePaymentStatusEnum
{
    Pending = 'Pending',
    Completed = 'Completed',
    Canceled = 'Canceled',
    NotStarted = 'NotStarted',
    Failed = 'Failed',
    NotConfirmed = 'NotConfirmed'
}

export const StorePaymentStatusOptions = (): Option[] => ([
    { value: StorePaymentStatusEnum.Pending, text: $t('[[[Oczekuje na płatność]]]') },
    { value: StorePaymentStatusEnum.NotStarted, text: $t('[[[Nieopłacone]]]') },
    { value: StorePaymentStatusEnum.NotConfirmed, text: $t('[[[Niepotwierdzona]]]') },
    { value: StorePaymentStatusEnum.Completed, text: $t('[[[Opłacone]]]') },
    { value: StorePaymentStatusEnum.Failed, text: $t('[[[Błąd płatności]]]') },
    { value: StorePaymentStatusEnum.Canceled, text: $t('[[[Anulowane]]]') }
]);

export const StorePaymentStatusName = (value: StorePaymentStatusEnum): string => StorePaymentStatusOptions().find(p => p.value === value)?.text || StorePaymentStatusEnum[value];

// ----------------------------------------------------------------------------------------------------

export enum StoreDeliveryStatusEnum
{
    AwaitingShipment = 'AwaitingShipment',
    Preparation = 'Preparation',
    Sent = 'Sent',
    Transit = 'Transit',
    ReadyToPickup = 'ReadyToPickup',
    Delivered = 'Delivered',
    DeliveryAttemptFailed = 'DeliveryAttemptFailed',
    PickedUpAtLocation = 'PickedUpAtLocation',
    Returned = 'Returned',
    Canceled = 'Canceled',
    Unknown = 'Unknown'
}

export const StoreDeliveryStatusOptions = (): Option[] => ([
    { value: StoreDeliveryStatusEnum.AwaitingShipment, text: $t('[[[Oczekuje na wysyłkę]]]') },
    { value: StoreDeliveryStatusEnum.Preparation, text: $t('[[[W trakcie przygotowania]]]') },
    { value: StoreDeliveryStatusEnum.Sent, text: $t('[[[Wysłane]]]') },
    { value: StoreDeliveryStatusEnum.Transit, text: $t('[[[W drodze]]]') },
    { value: StoreDeliveryStatusEnum.ReadyToPickup, text: $t('[[[Do odebrania w punkcie]]]') },
    { value: StoreDeliveryStatusEnum.Delivered, text: $t('[[[Dostarczone]]]') },
    { value: StoreDeliveryStatusEnum.PickedUpAtLocation, text: $t('[[[Odebrane w punkcie]]]') },
    { value: StoreDeliveryStatusEnum.DeliveryAttemptFailed, text: $t('[[[Nieudana próba doręczenia]]]') },
    { value: StoreDeliveryStatusEnum.Returned, text: $t('[[[Zwrot do nadawcy]]]') },
    { value: StoreDeliveryStatusEnum.Canceled, text: $t('[[[Anulowane]]]') },
    { value: StoreDeliveryStatusEnum.Unknown, text: $t('[[[Nieznany status]]]') }
]);

export const StoreDeliveryStatusName = (value: StoreDeliveryStatusEnum): string => StoreDeliveryStatusOptions().find(p => p.value === value)?.text || StoreDeliveryStatusEnum[value];

// ----------------------------------------------------------------------------------------------------

export enum StoreOrderStatusTypeEnum
{
    Order = 'Order',
    Payment = 'Payment',
    Delivery = 'Delivery'
}

export const StoreOrderStatusTypeOptions = (): Option[] => ([
    { value: StoreOrderStatusTypeEnum.Order, text: $t('[[[Ogólny]]]') },
    { value: StoreOrderStatusTypeEnum.Payment, text: $t('[[[Płatność]]]') },
    { value: StoreOrderStatusTypeEnum.Delivery, text: $t('[[[Dostawa]]]') }
]);

export const StoreOrderStatusTypeName = (value: StoreOrderStatusTypeEnum): string => StoreOrderStatusTypeOptions().find(p => p.value === value)?.text || StoreOrderStatusTypeEnum[value];

// ----------------------------------------------------------------------------------------------------

export enum StoreOrderParcelPointDeliveriesEnum
{
    ParcelMachine = 'ParcelMachine'
}

// ----------------------------------------------------------------------------------------------------

export enum StoreComplaintStatusEnum
{
    New = 'New',
    Consideration = 'Consideration',
    Approved = 'Approved',
    Rejected = 'Rejected'
}

export const StoreComplaintStatusOptions = (): Option[] => ([
    { value: StoreComplaintStatusEnum.New, text: $t('[[[Nowe zgłoszenie]]]') },
    { value: StoreComplaintStatusEnum.Consideration, text: $t('[[[W trakcie rozpatrywania]]]') },
    { value: StoreComplaintStatusEnum.Approved, text: $t('[[[Zaakceptowany]]]') },
    { value: StoreComplaintStatusEnum.Rejected, text: $t('[[[Odrzucony]]]') }
]);

export const StoreComplaintStatusName = (value: StoreComplaintStatusEnum): string => StoreComplaintStatusOptions().find(p => p.value === value)?.text || StoreComplaintStatusEnum[value];

// ----------------------------------------------------------------------------------------------------

export enum StoreComplaintTypeEnum
{
    Complaint = 'Complaint',
    DefectRemoval = 'DefectRemoval',
    PriceReduction = 'PriceReduction',
    Refund = 'Refund',
    Other = 'Other'
}

export const StoreComplaintTypeOptions = (): Option[] => ([
    { value: StoreComplaintTypeEnum.Complaint, text: $t('[[[Reklamacja]]]') },
    { value: StoreComplaintTypeEnum.DefectRemoval, text: $t('[[[Usunięcie wady]]]') },
    { value: StoreComplaintTypeEnum.PriceReduction, text: $t('[[[Obniżenie ceny]]]') },
    { value: StoreComplaintTypeEnum.Refund, text: $t('[[[Zwrot]]]') },
    { value: StoreComplaintTypeEnum.Other, text: $t('[[[Inne oczekiwania]]]') }
]);

export const StoreComplaintTypeName = (value: StoreComplaintTypeEnum): string => StoreComplaintTypeOptions().find(p => p.value === value)?.text || StoreComplaintTypeEnum[value];
